import { Radio } from 'antd';

const ChoixMultipleShare = ({ options = [], disabled = false, onChange, value }) => {
  const handleChange = (e) => {
    onChange(e.target.value); 
  };

  return (
    <Radio.Group
      onChange={handleChange}
      value={value}
      disabled={disabled}
    >
      {options.map((opt, index) => (
        <Radio
          key={index}
          value={opt.value || opt}
        >
          {opt.label || opt}
        </Radio>
      ))}
    </Radio.Group>
  );
};

export default ChoixMultipleShare;
